const DEGREE = 180 / Math.PI;

const toDegree = function(radian: number): number {
  return DEGREE * radian;
};

export default toDegree;
